import { Component, inject, Injectable, output } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import {
  DateRange,
  MAT_DATE_RANGE_SELECTION_STRATEGY,
  MatDatepickerInputEvent,
  MatDatepickerModule,
  MatDateRangePicker,
  MatDateRangeSelectionStrategy,
} from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';

@Injectable()
export class WeekRangeSelectionStrategy<D>
  implements MatDateRangeSelectionStrategy<D>
{
  private _dateAdapter = inject(DateAdapter<D>);

  selectionFinished(date: D | null): DateRange<D> {
    return this._createWeekRange(date);
  }

  createPreview(activeDate: D | null): DateRange<D> {
    return this._createWeekRange(activeDate);
  }

  private _createWeekRange(date: D | null): DateRange<D> {
    if (date) {
      const start = this._dateAdapter.addCalendarDays(date, 0);
      const end = this._dateAdapter.addCalendarDays(date, 6);
      return new DateRange<D>(start, end);
    }

    return new DateRange<D>(null, null);
  }
}

@Component({
  imports: [MatDatepickerModule, MatFormFieldModule, MatIconModule],
  providers: [
    {
      provide: MAT_DATE_RANGE_SELECTION_STRATEGY,
      useClass: WeekRangeSelectionStrategy,
    },
  ],
  selector: 'norupe-week-picker',
  styles: ``,
  templateUrl: './week-picker.component.html',
})
export class WeekPickerComponent {
  startDate = output<Date | null>();
  endDate = output<Date | null>();

  onStartDateSelected(date: MatDatepickerInputEvent<Date>) {
    this.startDate.emit(date.value);
  }
  onEndDateSelected(date: MatDatepickerInputEvent<Date>) {
    this.endDate.emit(date.value);
  }

  clearDate(picker: MatDateRangePicker<Date | null>) {
    picker.select(null);
  }
}
